module.exports = "<button class=\"button button button-assertive button-outline\" ng-click=\"$ctrl.openFilters()\">{{ 'filters' | translate | ucfirst }}</button>"


//////////////////
// WEBPACK FOOTER
// ./app/components/filterButton/filterButton.html
// module id = 402
// module chunks = 0